import { Component, OnInit,ViewChild } from '@angular/core';
import { BilleteraService } from '../../../Services/Api.Billetera/BilleteraService'
import { MatDialog } from '@angular/material';
import { OpenModal } from 'src/app/OpenModal';
import { TypeDialog, ButtonsDialog } from "src/app/model-type";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { ServicesCommon } from 'src/app/Services/Api.Common/ServicesCommon';
import { VentasAddComponent } from '../ventas-add/ventas-add.component';
import { VentasAddConductorComponent } from '../ventas-add-conductor/ventas-add-conductor.component';

import { CurrencyPipe} from '@angular/common';
import { RespuestaItem } from 'src/app/Models/Shared/Respuesta';
import { TableUtil } from 'src/tableUtil';

@Component({
  selector: 'app-ventas-list',
  templateUrl: './ventas-list.component.html',
  styleUrls: ['./ventas-list.component.css']
})
export class VentasListComponent implements OnInit {
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  dataSource = new MatTableDataSource();
  //tipos: Tipo[] = [];
  displayedColumns: string[] = ['fechaHoraAutorizacion','tipoDocumento', 'numeroDocumento','nombreCompleto','montoTotal','montoIVA','estado','eliminar','activar']
  dialogRef: any;
  loading = false;
  empty = false;

  constructor(private _BilleteraService: BilleteraService, public dialog: MatDialog,private OModal: OpenModal) {
    this.ObtenerVentas();
  }

  ngOnInit() {
    this.loading = false;
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  ObtenerVentas() {
    this._BilleteraService.obtenerVentas().subscribe(res => {      
      const record = (res as any).recordset;
      this.empty = (res as any).error == null && record == null;
      if (record != null) {        
        this.dataSource.data = record.sort((a, b) => { return a.orden - b.orden; });
        this.dataSource.paginator = this.paginator;
      } else if (!this.empty) {
        this.OModal.openDialog(
          TypeDialog.information,
          "Advertencia",
          "No fue posible obtener los usuarios.",
          ButtonsDialog.ok,
          300
        );
      }
      this.loading = false;
    });
  }

  onNuevoRegistroVenta() {
    this.dialogRef = this.dialog.open(VentasAddComponent, {
      width: "900px",
      data: 1
    });

    this.dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.OModal.openDialog(
          TypeDialog.success,
          "Éxito",
          "Registro Creado.",
          ButtonsDialog.ok,
          300
        );
        this.ObtenerVentas();
      }
    });
  }

  onNuevoRegistroVentaConductor() {
    this.dialogRef = this.dialog.open(VentasAddConductorComponent, {
      width: "900px",
      data: 1
    });

    this.dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.OModal.openDialog(
          TypeDialog.success,
          "Éxito",
          "Registro Creado.",
          ButtonsDialog.ok,
          300
        );
        this.ObtenerVentas();
      }
    });
  }


  onEliminar(objeto: any) {
    const dialogRef = this.OModal.openDialog(
      TypeDialog.information,
      "Advertencia",
      "¿Está seguro que desea cancelar la transacción?",
      ButtonsDialog.okcancel,
      300
    );
    dialogRef.afterClosed().subscribe((resp: number) => {
      if (resp === 1) {
        this.loading = true;
        this._BilleteraService.cancelarVenta(objeto.ventaID).subscribe(
          (res:RespuestaItem) => {            
            if (res.record != null) {
              this.OModal.openDialog(
                TypeDialog.success,
                "Éxito",
                "Transacción cancelada con exito.",
                ButtonsDialog.ok,
                300
              );
            }
            else if(res.error != null){
              this.OModal.openDialog(
                TypeDialog.warn,
                "Error",
                "No es posible cambiar el estado.",
                ButtonsDialog.ok,
                300
              );
            }
            this.ObtenerVentas();
          },
          (err) => {
            console.error(err);
          },
          () => (this.loading = false)
        );
      }
    });
  }

  onActivar() {
    this.dataSource.data = [];
    this.ObtenerVentas();
  }
  exportTable() {
    if(this.dataSource.filter){
    TableUtil.exportArrayToExcel(
      this.dataSource.data.filter((x)=>{
        return JSON.stringify(x).toLowerCase().includes(this.dataSource.filter)}),
      "Ventas"
      );
    }
    else
        TableUtil.exportArrayToExcel(
          this.dataSource.data,
          "usuarios"
        );  
    }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

}
